var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3944_112232",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3944_112232)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -15.25,
    width: 34.75,
    height: 55.75,
    fill: "#63CC60"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3944_112232",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3944_112232",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAEp0lEQVR4nO2dzYscRRTAfxcTTaJrxET0JghiFPEDIfhxEAQloogXPZgcBfEQFHUPQdyLbpKbYOIHngTzH/gBirqCOodt9aAInkSDxhiN5kNNND4peQ3j7sxkuru66k33+8G77VRP/d5sTU911StwHMdxHMdxHMfJw3rgaeB74C/gM+ARYG2EttdqW58Df+s19ug1HWANMABkRBwEdgLraphap689OKbtj/TaveepMYKG4xDwJLBhClsb9G8PTdFuuHavuRD4eQpRZRwBFvR1o8SHT/wPFdo7ClxEj1msIGs4jgG7Vd4FwDzwS822nqOnXAqcrCltOBHHGrZxQt9L73ixobiYsY+ecTlwyoD4Mk4DV9AjDhiQLividXrCtcAZA8JlRfwDXE8PeNOAbBkTb9Bx7jIgWc4S2+gAc8CNwA7geeAd4LABuTJlhFvbZeA1/Y1xD3AJRrkKeEgnuMLw8q0BgdJShHmlt4G9+uHaklP8ZmDJgBTJHEvqIinnAF8a6LwYiS/USTJ2GOi0GIswDCfjVQMdFmPxcsoE7DPQYTEWL6RMwBMGOizG4vGUCbjPQIfFWNybMgFXG+iwGIvweygZ5xqdUJNMcUadJKXLv3ilYnxDBt4z0HExEu/mSMArBjouEWLQYHFAGS9ZXc9jPZaBjdqf+QbthNvy5NzfIfk0TEK4Lc/yaLFL8psk4Roy8IABkVJzzA8PjCaxULHN4CIpdxtbViIR5ZdU+WI+pU6ScAfwhwGZEnHYWcnchBXbk5LQ+vPkW4DjBmSKMfll/A7c3pb8rRHWYXZZvmiE9a63xZZ/XYPVx32SLxq/AjfFvN08YkCmzIj84b0HNzSVf2XFDQ9WYjmz/DIO69R9LTZP2F/VRixGElHlVrNN+WV8B2yqk4DdCeUvRBJiTX4Zz9ZJwIeJ3twzI8R8MsPDzqh4v04CljLIr5sEy/JFn52YG4IWIomyOuw0HoLa/BJejCRsMAPyw5fwxRi7DS0q7M+dGzMcWR92Gt+Gtv1DrGiQhFmQf1T3SJieiihqJGEW5P8Wcyqi5OaWZkIHFcdx62P+cXXV2nT0icz/CZbltzod3fYDmSJSEnLJT/JApuRO4E+DSZjLJP+0buRLyoMtdWZQYZy3IF/URaeWpRQV/xNyyhd10bmFWcWUScgtX9RFJ5cmFmdJggX52UqfpVqcW4xJghX5oi46vTy9WJEES/JrTzfP2gaNQpNgTb6oi6Scl2mL0sCg/LLWUHCSDN+kx6okNJ52roJvUyXvHgHfqE3eXTJeqoBVCdifMgFerINVCQhOkuHlaliVgO0pE+AFm8hbsCngJcv4T/4Hddd+xmKLDkl7taBdygW9kmGNz1va1+2pC3RUIUwX3Ao8PFS28icDAqXCqoaybOVOfQxrtmxlFbYZkCt9KNw6CS9dnBkv3m0Ai+XrD9Aj/AAHA+w38KnPMo9jhcuMHOJzUt9LL1lsIN6Pscp4kNvGEW35QW41mZ9C/I+69ub8yEcZhmv3njUTHrSHk08fa+kwz4/9MM//ywrH2X6t+w/CcbaPRiqGWh5n+6l+d3wF7KqZVMdxHMdxHMdxHJryL4s7dGSCBfRTAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickMark);
export default __webpack_public_path__ + "static/media/tickMark.acdb7aca56fd46e958ed43a51b81113b.svg";
export { ForwardRef as ReactComponent };